/*###########################################################################
// Sprig
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"
import { ScrollTrigger } from "gsap/ScrollTrigger";

const sprigInstance = {
  init() {
    const self = this

    if (typeof htmx !== 'undefined') {
			// Handle filter buttons that sync to select dropdowns
			//
			self.handleFilterButtons()

			// Add loading state
			//
			htmx.on('htmx:beforeRequest', function (event) {
				if (!event.target.classList.contains('js-btn-loadmore')) {
					let outerContainer = event.target.closest('[id^="entry-container-outer"]')

					if (outerContainer !== null) {
						outerContainer.classList.add('is-loading')
					}

					if (outerContainer === null) {
						if (event.target.closest('section') !== null) {
							outerContainer = event.target.closest('section').querySelector('[id^="entry-container-outer"]')
						} else if (event.target.querySelector('section') !== null) {
							outerContainer = event.target.querySelector('section').querySelector('[id^="entry-container-outer"]')
						}

						if (outerContainer !== null) {
							outerContainer.classList.add('is-loading')
						}
					}
				} else if (event.target.classList.contains('js-btn-loadmore')) {
					event.target.disabled = true
					event.target.classList.add('cursor-wait', 'opacity-50')
				}
			})

			// After swap re-add event listeners for the above and remove loading state
			//
			htmx.on('htmx:afterSwap', function (event) {
				setTimeout(function() {
					if (!event.target.classList.contains('js-btn-loadmore')) {
						let outerContainer = event.target.closest('[id^="entry-container-outer"]')

						if (outerContainer !== null) {
							outerContainer.classList.remove('is-loading')
						}

						if (outerContainer === null) {
							if (event.target.closest('section') !== null) {
								outerContainer = event.target.closest('section').querySelector('[id^="entry-container-outer"]')
							} else if (event.target.querySelector('section') !== null) {
								outerContainer = event.target.querySelector('section').querySelector('[id^="entry-container-outer"]')
							}

							if (outerContainer !== null) {
								outerContainer.classList.remove('is-loading')
							}
						} else if (event.target.classList.contains('js-btn-loadmore')) {
							event.target.disabled = false
							event.target.classList.remove('cursor-wait', 'opacity-50')
						}
					}

					ScrollTrigger.refresh()
				}, 500)

				// Handle filter buttons that sync to select dropdowns
				//
				self.handleFilterButtons()
			})
		}
  },

	handleFilterButtons() {
		const self = this

		const filterButtons = document.querySelectorAll('button[data-select]')

		const buttonDark = document.querySelector('button[data-select].pillBtn--dark')
		const buttonLight = document.querySelector('button[data-select].pillBtn--light')
		let activeClass = ''

		if (buttonDark !== null) {
			activeClass = 'pillBtn--dark'
		} else if (buttonLight !== null) {
			activeClass = 'pillBtn--light'
		}

		if (filterButtons.length === 0) {
			return
		}

		filterButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				const selectToSync = document.querySelector(button.getAttribute('data-select'))

				if (selectToSync) {
					selectToSync.value = button.getAttribute('data-value')
					selectToSync.dispatchEvent(new Event('change', { bubbles: true }))
				}

				filterButtons.forEach((button) => {
					button.classList.remove(activeClass)
				})
				button.classList.add(activeClass)

				self.scrollToContainer()
			})
		})
	},

  scrollToContainer() {
    const offsetAmount = document.querySelector('.header').clientHeight + 40
    scrollTo(document.querySelector('#entry-container'), -offsetAmount)
  }
}

initComponent(() => {
	sprigInstance.init()
})
